export class CopyBackgroundInfoErrorResponse {
  sourceId: any;
}
